<div class='form-group'>
    <label class="control-label">{{LOCALIZATION.locateBy}}</label>
    <select class='form-control' [(ngModel)]='locateform.locateControl' name="locateControl" (change)="updateLocateControl()" aria-label="Locate By Type">
		<option *ngFor="let loc of locateControls" value="{{loc}}">{{loc.name}}</option>
	</select>  
</div>
<form *ngIf="locateform?.locateControl?.type === 'ces'">
    <div class='row'>
        <div class="form-group col-md-6">
            <label class="control-label">{{LOCALIZATION.shape}}</label>
            <div class="controls">
                <select [(ngModel)]='aoi.shape' name="aoiShape" class="form-control" aria-label="Shape">
                    <option value='rectangle'>{{LOCALIZATION.rectangle}}</option>
                    <option value='circle'>{{LOCALIZATION.circle}}</option>
                </select>
            </div>
        </div>
        <div class="form-group col-md-6">
            <label class="control-label">{{LOCALIZATION.format}}</label>
            <div class="controls">
                <select [(ngModel)]='aoi.mode' name="aoiMode" class="form-control" aria-label="Coordinate Format">
                    <option value='DDD'>{{LOCALIZATION.DDD}}</option>
                    <option value='DMS'>{{LOCALIZATION.DMS}}</option>
                    <option value='UTM'>{{LOCALIZATION.UTM}}</option>
                    <option value="MGRS">{{LOCALIZATION.MGRS}}</option>
                </select>
            </div>
        </div>
    </div>
    <label *ngIf='aoi.shape === "rectangle" && aoi.mode !== "DMS"' class="control-label">{{LOCALIZATION.upperLeft}}</label>
    <label *ngIf='aoi.shape === "circle" && aoi.mode !== "DMS"' class="control-label">{{LOCALIZATION.center}}</label>
    <div *ngIf="aoi.mode === 'MGRS'" class="row">
        <div class="form-group col-md-12">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.gridReference}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.mgrs1.point' name="aoiMgrs1Point" aria-label="Grid Reference" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf='aoi.mode === "DDD"' class='row'>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.latitudey}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ddd1.y' name="aoiDdd1Y" aria-label="Y (Lat)" />
                </div>
            </div>
        </div>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.longitudex}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ddd1.x' name="aoiDdd1X" aria-label="X (Lon)" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf='aoi.mode === "UTM"' class='row'>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.northing}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.utm1.northing' name="aoiUtm1Northing" aria-label="Northing" />
                </div>
            </div>
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.zone}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.utm1.zone' name="aoiUtm1Zone" aria-label="Zone" />
                </div>
            </div>
        </div>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.easting}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.utm1.easting' name="aoiUtm1Easting" aria-label="Easting" />
                </div>
            </div>
            <div class="controls">
                <div class="input-group">
                    <select class='form-control' [(ngModel)]='aoi.utm1.utmHemisphere' name="aoiUtm1UtmHemisphere" aria-label="Hemisphere">
                        <option value="North">{{LOCALIZATION.north}}</option>
                        <option value="South">{{LOCALIZATION.south}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf='aoi.mode === "CCS"' class='row'>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.northing}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ccs.northing' name="aoiCcsNorthing" aria-label="Northing" />
                </div>
            </div>
        </div>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.easting}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ccs.easting' name="aoiCcsEasting" aria-label="Easting" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf='aoi.mode === "DMS"' class='row'>
        <div class='form-group col-md-9'>
            <label *ngIf='aoi.shape === "rectangle" && aoi.mode === "DMS"'
                   class="control-label">{{LOCALIZATION.upperLeft}} - {{LOCALIZATION.latitudey}}</label>
            <label *ngIf='aoi.shape === "circle" && aoi.mode === "DMS"'
                   class="control-label">{{LOCALIZATION.center}} - {{LOCALIZATION.latitudey}}</label>
            <div class="controls">
                <div class="input-group">
                    <input type="text" class="form-control" aria-label="DMS Lat Degrees" [(ngModel)]='aoi.dms1.yd' name="aoiDms1yd" />
                    <span class="input-group-addon">°</span>
                    <input type="text" class="form-control" aria-label="DMS Lat Minutes" [(ngModel)]='aoi.dms1.ym' name="aoiDms1ym" />
                    <span class="input-group-addon">'</span>
                    <input type="text" class="form-control" aria-label="DMS Lat Seconds" [(ngModel)]='aoi.dms1.ys' name="aoiDms1ys" />
                    <span class="input-group-addon">"</span>
                </div>
            </div>
        </div>
        <div class='form-group col-md-3'>
            <label>{{LOCALIZATION.direction}}</label>
            <select class='form-control' [(ngModel)]='aoi.dms1.yh' name="aoiDms1yh" aria-label="Direction">
                <option value="North">{{LOCALIZATION.north}}</option>
                <option value="South">{{LOCALIZATION.south}}</option>
            </select>
        </div>
    </div>
    <div *ngIf='aoi.mode === "DMS"' class='row'>
        <div class='form-group col-md-9'>
            <label *ngIf='aoi.shape === "rectangle" && aoi.mode === "DMS"'
                   class="control-label">{{LOCALIZATION.upperLeft}} - {{LOCALIZATION.longitudex}}</label>
            <label *ngIf='aoi.shape === "circle" && aoi.mode === "DMS"'
                   class="control-label">{{LOCALIZATION.center}} - {{LOCALIZATION.longitudex}}</label>
            <div class="controls">
                <div class="input-group">
                    <input type="text" class="form-control" aria-label="DMS Lon Degrees" [(ngModel)]='aoi.dms1.xd' name="aoiDms1xd" />
                    <span class="input-group-addon">°</span>
                    <input type="text" class="form-control" aria-label="DMS Lon Minutes" [(ngModel)]='aoi.dms1.xm' name="aoiDms1xm" />
                    <span class="input-group-addon">'</span>
                    <input type="text" class="form-control" aria-label="DMS Lon Seconds" [(ngModel)]='aoi.dms1.xs' name="aoiDms1xs" />
                    <span class="input-group-addon">"</span>
                </div>
            </div>
        </div>
        <div class='form-group col-md-3'>
            <label>{{LOCALIZATION.direction}}</label>
            <select class='form-control' [(ngModel)]='aoi.dms1.xh' name="aoiDms1xh" aria-label="Direction">
                <option value="East">{{LOCALIZATION.east}}</option>
                <option value="West">{{LOCALIZATION.west}}</option>
            </select>
        </div>
    </div>
    <div *ngIf='aoi.mode === "DMS" && aoi.shape === "rectangle"' class='row'>
        <div class='form-group col-md-9'>
            <label class="control-label">{{LOCALIZATION.bottomRight}} - {{LOCALIZATION.latitudey}}</label>
            <div class="controls">
                <div class="input-group">
                    <input type="text" class="form-control" aria-label="DMS Lat Degrees" [(ngModel)]='aoi.dms2.yd' name="aoiDms2yd" />
                    <span class="input-group-addon">°</span>
                    <input type="text" class="form-control" aria-label="DMS Lat Minutes" [(ngModel)]='aoi.dms2.ym' name="aoiDms2ym" />
                    <span class="input-group-addon">'</span>
                    <input type="text" class="form-control" aria-label="DMS Lat Seconds" [(ngModel)]='aoi.dms2.ys' name="aoiDms2ys" />
                    <span class="input-group-addon">"</span>
                </div>
            </div>
        </div>
        <div class='form-group col-md-3'>
            <label>{{LOCALIZATION.direction}}</label>
            <select class='form-control' [(ngModel)]='aoi.dms2.yh' name="aoiDms2yh" aria-label="Direction">
                <option value="North">{{LOCALIZATION.north}}</option>
                <option value="South">{{LOCALIZATION.south}}</option>
            </select>
        </div>
    </div>
    <div *ngIf='aoi.mode === "DMS" && aoi.shape === "rectangle"' class='row'>
        <div class='form-group col-md-9'>
            <label class="control-label">{{LOCALIZATION.bottomRight}} - {{LOCALIZATION.longitudex}}</label>
            <div class="controls">
                <div class="input-group">
                    <input type="text" class="form-control" aria-label="DMS Lon Degrees" [(ngModel)]='aoi.dms2.xd' name="aoiDms2xd" />
                    <span class="input-group-addon">°</span>
                    <input type="text" class="form-control" aria-label="DMS Lon Minutes"  [(ngModel)]='aoi.dms2.xm' name="aoiDms2xm" />
                    <span class="input-group-addon">'</span>
                    <input type="text" class="form-control" aria-label="DMS Lon Seconds" [(ngModel)]='aoi.dms2.xs' name="aoiDms2xs" />
                    <span class="input-group-addon">"</span>
                </div>
            </div>
        </div>
        <div class='form-group col-md-3'>
            <label>{{LOCALIZATION.direction}}</label>
            <select class='form-control' [(ngModel)]='aoi.dms2.xh' name="aoiDms2xh" aria-label="Direction">
                <option value="East">{{LOCALIZATION.east}}</option>
                <option value="West">{{LOCALIZATION.west}}</option>
            </select>
        </div>
    </div>
    <label *ngIf='aoi.shape === "rectangle" && aoi.mode !== "DMS"'
           class="control-label">{{LOCALIZATION.bottomRight}}</label>
    <div *ngIf='aoi.mode === "MGRS" && aoi.shape === "rectangle"' class='row'>
        <div class="form-group col-md-12">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.gridReference}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.mgrs2.point' aria-label="Grid Reference" name="aoiMgrs2Point" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf='aoi.mode === "DDD" && aoi.shape === "rectangle"' class='row'>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.latitudey}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ddd2.y' aria-label="Y (Lat)" name="aoiDdd2y" />
                </div>
            </div>
        </div>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.longitudex}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ddd2.x' aria-label="X (Lon)" name="aoiDdd2x" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf='aoi.mode === "UTM" && aoi.shape === "rectangle"' class='row'>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.northing}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.utm2.northing' aria-label="Northing" name="aoiUtm2Northing" />
                </div>
            </div>
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.zone}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.utm2.zone' aria-label="Zone" name="aoiUtm2Zone" />
                </div>
            </div>
        </div>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.easting}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.utm2.easting' aria-label="Easting" name="aoiUtm2Easting" />
                </div>
            </div>
            <div class="controls">
                <div class="input-group">
                    <select class='form-control' [(ngModel)]='aoi.utm2.utmHemisphere' name="aoiUtm2utmhemisphere" aria-label="Direction">
                        <option value="North">{{LOCALIZATION.north}}</option>
                        <option value="South">{{LOCALIZATION.south}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf='aoi.mode === "CCS" && aoi.shape === "rectangle"' class='row'>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.northing}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ccs2.northing' aria-label="Northing" name="aoiCcs2Northing" />
                </div>
            </div>
        </div>
        <div class="form-group col-md-6">
            <div class="controls">
                <div class="input-group">
                    <div class="input-group-addon">{{LOCALIZATION.easting}}</div>
                    <input type="text" class="form-control" [(ngModel)]='aoi.ccs2.easting' aria-label="Easting" name="aoiCcs2Easting" />
                </div>
            </div>
        </div>
    </div>
    <label *ngIf='aoi.shape === "circle"' class="control-label">{{LOCALIZATION.radius}}</label>
    <div *ngIf='aoi.shape === "circle"' class='row'>
        <div class="form-group col-md-12">
            <div class="controls">
                <div class="input-group">
                    <input type="text" class="form-control" [(ngModel)]='aoi.radius' name='aoiRadius' style='width:50%' aria-label="Radius">
                    <select class='form-control' [(ngModel)]='aoi.radiusType' name="aoiRadiusType" style='width:50%' aria-label="Radius Unit of Measurement">
                        <option label="Feet" value="feet">{{LOCALIZATION.feet}}</option>
                        <option label="Miles" value="miles" selected="selected">{{LOCALIZATION.miles}}</option>
                        <option label="Meters" value="meters">{{LOCALIZATION.meters}}</option>
                        <option label="Kilometers" value="kilometers">{{LOCALIZATION.kilometers}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="text-center primary-controls">
        <button class='btn btn-primary' (click)='updateAoiManually(true)'>{{LOCALIZATION.locate}}</button>
        <button class='btn btn-primary' (click)='updateAoiManually(false)'>{{LOCALIZATION.searchArea}}</button>
    </div>
</form>
